<template>
    <li @click="itemClicked" class="academy-course-item">
        <img :src="item.coverPic+'@140h_230w_2e_90Q'" />
        <h3 :title="item.title">{{item.title}}</h3>
        <h5 :title="item.subTitle">{{item.subTitle}}</h5>
    </li>
</template>
<script>
    let propsRequired = ["id", "title", "coverPic"];
    export default {
      props: {
        item: {
          type: Object,
          validator: function(val) {
            let valid = true;
            propsRequired.forEach(prop => {
              if (!valid) {
                return;
              }
              valid = Boolean(val[prop]);
            });
            return valid;
          }
        }
      },
      methods: {
        itemClicked() {
          this.$emit("itemClicked", this.item);
        }
      }
    };
</script>
<style lang="postcss" scoped>
li.academy-course-item {
  width: 230px;
  cursor: pointer;
  margin-top: 20px;
  margin-right: 26.6px;
  position: relative;
  &:hover {
    h3,
    h5 {
      color: #37a6fc;
    }
    img {
      box-shadow: 0 4px 8px rgba(40, 40, 40, 0.2);
    }
  }
  .top {
    display: block;
    position: absolute;
    width: 66px;
    height: 22px;
    background-color: #ff4116;
    border-radius: 11px;
    left: 10px;
    top: 10px;
    background-image: url(https://p0.meituan.net/codeman/35d9ac2e1b7b1cb9b0dedab63ed15e691004.png);
    background-size: 10px 11px;
    background-repeat: no-repeat;
    background-position: 11px 5px;
    font-size: 14px;
    line-height: 22px;
    padding-left: 26px;
    color: #fff;
  }
  &:nth-child(4n) {
    margin-right: 0;
  }
  h3,
  h5 {
    margin: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  img {
    width: 230px;
    height: 140px;
    display: block;
  }
  h3 {
    font-size: 16px;
    margin-top: 10px;
    line-height: 25px;
    color: #152c3c;
    font-weight: normal;
  }
  h5 {
    margin-top: 4px;
    font-size: 12px;
    line-height: 17px;
    color: #6e808b;
    font-weight: normal;
  }
}
</style>




// WEBPACK FOOTER //
// Announcement.vue?82ae5eee